import type { SentenceOffset } from '@chegg-wt/core-wa/state/types'

// example - substring = ' n incomplete,', completeText = 'This is an incomplete, word-example in a sentence.' output = 'an incomplete'
export const getCompleteWords = (
  sentence: string,
  oldStartIndex: number,
  oldEndIndex: number
) => {
  if (sentence.length < 1)
    return {
      completeWords: '',
      newStartIndex: 0,
      newEndIndex: 0,
    }

  let newStartIndex = oldStartIndex === -1 ? 0 : oldStartIndex // handle 1 space between sentences
  let newEndIndex = oldEndIndex - 1
  const isPunctuationOrSpace = (str?: string) => str?.search(/\W/) !== -1

  // ? move startIndex right
  while (
    newStartIndex < sentence.length - 1 &&
    isPunctuationOrSpace(sentence[newStartIndex])
  ) {
    newStartIndex += 1
  }
  // ? move startIndex left
  while (newStartIndex > 0 && !isPunctuationOrSpace(sentence[newStartIndex - 1])) {
    newStartIndex -= 1
  }

  if (newEndIndex > sentence.length - 1) {
    // set selection to end of sentence if out of bounds
    newEndIndex = sentence.length - 2 // to avoid sentence end punctuation
  } else {
    // ? move endIndex left
    while (newEndIndex > 0 && isPunctuationOrSpace(sentence[newEndIndex])) {
      newEndIndex -= 1
    }
    // ? move endIndex right
    while (
      newEndIndex < sentence.length - 1 &&
      !isPunctuationOrSpace(sentence[newEndIndex + 1])
    ) {
      newEndIndex += 1
    }
  }

  const completeWords = sentence.substring(newStartIndex, newEndIndex + 1)
  return { completeWords, newStartIndex, newEndIndex }
}

export const getSelectedSentences = (
  sentenceOffsets: SentenceOffset[],
  from: number,
  to: number
): SentenceOffset[] => {
  const selectedSentenceOffsets = []
  let fromFound = false
  for (
    let sentenceIndex = 0;
    sentenceIndex < sentenceOffsets.length;
    sentenceIndex += 1
  ) {
    const sentenceOffSet = sentenceOffsets[sentenceIndex]
    const { length, offset } = sentenceOffSet
    const totalLength = offset + length
    if (fromFound || from <= totalLength - 1) {
      selectedSentenceOffsets.push(sentenceOffSet)
      fromFound = true
      if (to <= totalLength) break
    }
  }

  return selectedSentenceOffsets
}
